<template>
<div class="cv-microcopy" aria-hidden="true">
      <span class="chip bold-red">＼業界最安値級・最短で今日お湯が使える！／</span>
    </div>
  <div class="button-container">
    <a
      :href="affiliateLink"
      rel="nofollow noopener"
      class="official-website-button"
      target="_blank"
      aria-label="WEBで簡単！無料見積もりはこちらから（新しいタブで開く）"
      @click="affClick"
    >
      電話一本で簡単！<br>無料見積もりはこちらから
    </a>

    <p class="website-link">
      <a :href="affiliateLink" target="_blank" rel="nofollow noopener"  @click="affClick">
        https://kyutouki-kaketsuketai.com
      </a>
    </p>
  </div>
</template>

<script>
import { makeAffiliateUrl } from '../../utils/aff.js';
import { affClick } from '../../utils/affClick.js'; 
export default {
  computed: {
    affiliateLink() {
      return makeAffiliateUrl();
    }
  },
    methods: {
        affClick
    }
};
</script>

<style scoped>
.button-container{
  text-align:center;
  padding-top:0;
}

/* 上のコピーはそのまま */
.microcopy{
  font-size:0.5rem;
  margin:0 0 8px;
  padding:0;
}

.cv-microcopy {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.cv-microcopy .chip {
  font-size: .8rem;
  padding-bottom: 5px;
  font-weight: 600;
}

/* ============= オレンジCTA ============= */
.official-website-button{
  /* 見た目トークン */
  --btn-bg:#ff7a00;
  --btn-bg-dark:#e96e00;
  --btn-grad-top:#ffa043;
  --btn-radius:999px;

  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:10px;

  /* レイアウト：はみ出し防止＆中央寄せ */
  width:100%;
  max-width:720px;
  box-sizing:border-box;

  /* タップ/視認性 */
  padding:22px 28px;
  font-size:1.1rem;
  font-weight:800;
  line-height:1.25;
  text-align:center;

  /* 配色・立体感 */
  color:#fff;
  text-decoration:none;
  background:linear-gradient(180deg, var(--btn-grad-top) 0%, var(--btn-bg) 40%, var(--btn-bg) 100%);
  border:2px solid var(--btn-bg-dark);
  border-radius:var(--btn-radius);
  box-shadow:var(--btn-shadow);
  position:relative;
  isolation:isolate;
  overflow:hidden;

  /* 触感 */
  transition:transform .08s ease, box-shadow .2s ease, filter .2s ease;
  will-change:transform, box-shadow, filter;
}

/* ▶ 矢印（HTML変更不要） */
.official-website-button::after{
  content:"▶";
  font-size:1em;
  translate:0 1px;
}

/* シャイン演出（既存を流用＆調整） */
.official-website-button::before{
  content:"";
  position:absolute;
  top:0;
  left:-80px;
  width:60px;
  height:100%;
  background:linear-gradient(90deg, rgba(255,255,255,.0) 0%, rgba(255,255,255,.55) 50%, rgba(255,255,255,.0) 100%);
  transform:skewX(-20deg);
  animation:shine 3.5s infinite;
  pointer-events:none;
}

@keyframes shine{
  0%{ left:-80px; }
  60%{ left:115%; }
  100%{ left:115%; }
}

.official-website-button:hover{
  transform:translateY(-1px);
  box-shadow:0 14px 28px rgba(233,110,0,.32);
  filter:brightness(1.02);
}
.official-website-button:active{
  transform:translateY(0);
  box-shadow:0 8px 16px rgba(233,110,0,.22);
}
.official-website-button:focus-visible{
  outline:none;
  box-shadow:
    0 0 0 3px #fff,
    0 0 0 6px rgba(255,122,0,.9),
    var(--btn-shadow);
}

.website-link{
  font-size:0.8rem;
  font-weight:700;
  margin-top: 0;
  margin-bottom: 20px;
}

.website-link a{
  color:#3f51b5;
  text-decoration:underline;
  word-break:break-all;
}

.official-website-button {
    width: 87%;
}

@media (max-width:600px){
  .official-website-button {
    width: 87%;
    font-size: 0.9rem
}
  .microcopy{ font-size:.95rem; margin-bottom:6px; }

  .official-website-button{
    font-size:1rem;
    padding:18px 20px;
    max-width:100%;
  }
  .website-link{ font-size:.85rem; }
}

@media (prefers-color-scheme:dark){
  .official-website-button{ filter:saturate(1.05) brightness(1.05); }
}
</style>
